import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Hair_15 = ({ hairColours }) => {
  const primary = hairColours.base;
  const secondary = hairColours.shadow;
  return (
    <>
      <g>
        <path
          fill={primary}
          d="M415.8,171.9c0,0-129.5-17.3-159.5,84.3c-29.9,101.6,30.7,353.2,49.5,373.7h14.9c0,0-73.1-320.1-15.9-356
		c57.2-35.9,152.2-43.4,172.7-26.9c20.5,16.4,79,65,20.3,196.2c0,0-16.3,180.3-11.9,193.7l14.9-1.7l1.4-10.7l5.9,10.2l13.2-13.2
		c0,0,79.5-315.6,21.6-385.6C542.9,235.7,493.2,173.9,415.8,171.9z"
        />
        <g>
          <path
            fill={primary}
            d="M290.9,251.3c0,0-3.9,14.6-4.7,29.7c-0.8,15.2,1.6,23.1,1.6,23.1l30.3-5.2c0,0,2.3-9.4,5.4-16.1
			c3.1-6.7,7.8-15.2,7.8-15.2s-2.3,15.8-3.1,20c-0.8,4.2,0,9.4,0,9.4s9.3-0.9,17.8-0.9c8.5,0,18.2,1.8,18.2,1.8s0.4-5.5,0.4-12.1
			c0-6.7,1.5-12.1,1.5-12.1s1.9,9.1,3.5,15.8c1.6,6.7,3.1,10.6,3.1,10.6l14.7,1.5c0,0-0.4-3.6-0.4-9.1c0-5.5-0.8-12.7-0.8-12.7
			s3.9,10.3,5.4,15.2c1.6,4.9,2.7,7.9,2.7,7.9l34.5,2.4v-28.2c0,0,3.9,13.6,5.4,21.5c1,5.1,2.3,6.7,2.3,6.7s10.5,0.6,19.8,1.8
			c9.3,1.2,17.5,3,17.5,3s0.7-3.3-0.5-13.6c-1.2-10.9-2.6-19.2-2.6-19.2s6.6,16.8,8.1,22.4c1.9,7.3,2.7,11.2,2.7,11.2
			c2.3,0.9,4.8,0.3,15.5,3.6C508.1,318,514,322,514,322s1.9-1.5,2.7-30c0.8-28.5,4.7-98.3-97-108C318,174.2,290.9,251.3,290.9,251.3
			z"
          />
          <path
            fill={primary}
            d="M290.9,251.3c0,0,4,7.9,4.7,23.1c0.8,17.3,1.9,24.9,1.9,24.9l20.2-3.9c0,0,1.6-5.8,4.7-12.4
			c3.1-6.7,8.9-15.2,8.9-15.2s-2.3,15.8-3.1,20c-0.8,4.2,0,9.4,0,9.4s9.3-0.9,17.8-0.9c8.5,0,18.2,1.8,18.2,1.8s0.4-5.5,0.4-12.1
			c0-6.7,1.5-12.1,1.5-12.1s1.9,9.1,3.5,15.8c1.6,6.7,3.1,10.6,3.1,10.6l14.7,1.5c0,0-0.4-3.6-0.4-9.1c0-5.5-0.8-12.7-0.8-12.7
			s3.9,10.3,5.4,15.2c1.6,4.9,2.7,7.9,2.7,7.9l34.5,2.4v-28.2c0,0,3.9,13.6,5.4,21.5c1,5.1,2.3,6.7,2.3,6.7s10.5,0.6,19.8,1.8
			c9.3,1.2,17.5,3,17.5,3s0.7-3.3-0.5-13.6c-1.2-10.9-2.6-19.2-2.6-19.2s8.6,14.1,10.1,19.7c1.9,7.3,1.9,10.3,1.9,10.3
			c2.3,0.9,6.3,1.2,17.1,4.5c10.9,3.3,11.6,2.4,11.6,2.4s1.9-9.1,0.4-34c-1.8-28.5,9.3-86.7-92.3-96.4
			C318,174.2,290.9,251.3,290.9,251.3z"
          />
          <path
            fill={primary}
            d="M297.9,259.2c0,0-13.2,73.4-5.4,129.2c7.8,55.8,21.7,115.9,35.7,148.6c14,32.8,18.6,108.2,18.6,108.2
			l-17.8-6.7l-5.4-4.9l-4.7-0.6c0,0-21.7-107-34.1-173.1c-12.4-66.1-26.4-145.6-18.6-181.4C273.8,242.8,297.9,259.2,297.9,259.2z"
          />
          <path
            fill={secondary}
            d="M299,253.4c0,0-16.9,82.6-9.1,138.5c7.8,55.8,21,112.4,34.9,145.1c14,32.8,18.6,104.4,18.6,104.4l-17.7-9.6
			l-13.2-94.3l3.9,84.6c0,0-16.5-95.9-28.9-162c-12.4-66.1-27-157.1-19.2-192.9C276.1,231.4,299,253.4,299,253.4z"
          />
          <path
            fill={secondary}
            d="M511.2,285.9c0,0,11.6,75.2-14.7,139.5c-26.4,64.3-32.6,174.9-31,193.1c1.6,18.2,7.8,31.5,7.8,31.5l-0.8-20
			l5.4,17l10.1-4.9l-2.3-19.4l7,17.6l4.7-3.6c0,0-16.3-101.5,0-147.6c16.3-46.1,37.2-94,50.4-140.7s2.3-83.7-14.7-113.4
			c-17.1-29.7-56.6-37-56.6-37L511.2,285.9z"
          />
          <path
            fill={primary}
            d="M511.2,285.9c0,0,16.3,76.4-10.1,140.7c-26.4,64.3-37.2,173.7-35.7,191.9c1.6,18.2,7.8,31.5,7.8,31.5
			l-2.3-107L481,643.4l0.8-99.1l10.9,89.4l4.7,3c0,0-16.8-100.8-3.7-147.5c13.2-47.2,36.9-94.3,50-141
			c13.2-46.7,10.7-83.6-6.4-113.3c-17.1-29.7-60.9-37-60.9-37L511.2,285.9z"
          />
        </g>
      </g>
    </>
  );
};

export default Hair_15;
